import { gql } from '@apollo/client';

export const GET_OFFER_DETAIL_PAGE_BY_SLUG = gql`
  query GetOfferDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    # Offer list Item
    meetingPlacePageOfferCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
        tenant {
          __typename
          ... on MeetingPlacePageTenantShop {
            sys {
              id
            }
          }
          ... on MeetingPlacePageTenantFoodBeverage {
            sys {
              id
            }
          }
          ... on MeetingPlacePageTenantEntertainment {
            sys {
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_OFFERS = gql`
  query GetAllOfferPages($tagId: String!) {
    meetingPlacePageOfferCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
    ) {
      items {
        sys {
          id
        }
        name
        validTo
        tenant {
          __typename
          ... on MeetingPlacePageTenantShop {
            sys {
              id
            }
          }
          ... on MeetingPlacePageTenantFoodBeverage {
            sys {
              id
            }
          }
          ... on MeetingPlacePageTenantEntertainment {
            sys {
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_OCCASIONS = gql`
  query GetAllOccasionsPages(
    $tagId: String!
    $limit: Int = 50
    $skip: Int = 0
  ) {
    meetingPlacePageOccasionsCollection(
      where: { contentfulMetadata: { tags: { id_contains_some: [$tagId] } } }
    ) {
      items {
        occasionsCollection(
          where: { sys: { id_exists: true } }
          limit: $limit
          skip: $skip
        ) {
          total
          items {
            ... on MeetingPlacePageOffer {
              sys {
                id
              }
              validTo
              tenant {
                ... on MeetingPlacePageTenantShop {
                  sys {
                    id
                  }
                }
                ... on MeetingPlacePageTenantFoodBeverage {
                  sys {
                    id
                  }
                }
                ... on MeetingPlacePageTenantEntertainment {
                  sys {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_NEWS_DETAIL_PAGE_BY_SLUG = gql`
  query GetNewsDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String
  ) {
    # News Page
    meetingPlacePageNewsItemCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_EVENT_DETAIL_PAGE_BY_SLUG = gql`
  query GetEventDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    # Events Page
    meetingPlacePageEventCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_LPO_DETAIL_PAGE_BY_SLUG = gql`
  query GetLPODetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    # LPO Page
    meetingPlacePageLeisurePackageOfferItemCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_TENANT_SHOP_DETAIL_PAGE_BY_SLUG = gql`
  query GetTenantShopDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    bySlug: meetingPlacePageTenantShopCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_TENANT_FOOD_BEVERAGE_DETAIL_PAGE_BY_SLUG = gql`
  query GetTenantFoodBeverageDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    bySlug: meetingPlacePageTenantFoodBeverageCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_TENANT_ENTERTAINMENT_DETAIL_PAGE_BY_SLUG = gql`
  query GetTenantEntertainmentDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    bySlug: meetingPlacePageTenantEntertainmentCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_TENANT_SERVICE_DETAIL_PAGE_BY_SLUG = gql`
  query GetServiceDetailPageBySlug(
    $slug: String!
    $tagId: String!
    $locale: String!
  ) {
    meetingPlacePageServiceCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

export const GET_TENANT_SERVICE_TYPE_DETAIL_PAGE_BY_SLUG = gql`
  query GetServiceTypeDetailPageBySlug(
    $slug: String!
    $locale: String!
    $preview: Boolean
  ) {
    libraryServiceTypeCollection(
      where: { slug: $slug }
      locale: $locale
      preview: $preview
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;

